module.exports = __webpack_public_path__ + "img/rm_3.8c829858.png";